export default __webpack_public_path__ + "static/media/logo_CodeWin.bb7c6d64.svg";